"use client";

import ViewsModal from "components/ui/v2/explore/bundle/ViewsModal";
import { Modal } from "components/ui/v2/modal";
import { TvMinimalPlay } from "lucide-react";
import { useTheme } from "next-themes";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";

export interface ExploreViewCounterV2Props {
  count: number | undefined;
  render?: boolean;
  messageId: string;
}

export function ExploreViewCounterV2({
  count,
  render = false,
  messageId,
}: ExploreViewCounterV2Props) {
  const { t } = useTranslation("common");
  const { theme } = useTheme();
  const [open, setOpen] = useState(false);
  const [viewsCount, setViewsCount] = useState(0);

  useEffect(() => {
    if (!open) {
      setViewsCount(0);
    }
  }, [open]);

  const formatCount = (value: number | undefined) => {
    if (value === undefined) return "0";
    if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
    if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
    if (value >= 1_000) return (value / 1_000).toFixed(1) + "k";
    return value.toString();
  };

  if (!render) return null;

  const title =
    viewsCount > 0 ? `${t("Vistas")} (${viewsCount})` : t("Vistas");

  return (
    <>
      <button
        type="button"
        className="flex cursor-pointer items-center gap-2 border-0 bg-transparent p-0"
        onClick={() => setOpen(true)}
      >
        <TvMinimalPlay
          strokeWidth={1}
          size={20}
          color={theme === "dark" ? "#a5a9b2" : "#666666"}
        />
        <div className="flex gap-1">
          <p className="text-xs text-[#666666] dark:text-gray-200">
            {formatCount(count)}
          </p>
          <span className="text-xs text-[#666666] dark:text-gray-200">
            {count === 1 ? t("Vista") : t("Vistas")}
          </span>
        </div>
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="md"
        backdrop="static"
        eyebrow={t("Explorar")}
        title={title}
        panelClassName="max-h-[min(88vh,680px)]"
        headerClassName="px-4 py-2.5 sm:px-5 sm:py-3"
        bodyClassName="px-4 py-3 sm:px-5 sm:py-3.5"
      >
        <ViewsModal
          messageId={messageId}
          onViewsCountChange={setViewsCount}
        />
      </Modal>
    </>
  );
}
